import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";

Vue.config.productionTip = false;

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("./components/HeroBanner.vue")
  },
  {
    path: "/website",
    name: "Projects",
    component: () => import("./components/Projects.vue")
  },
  {
    path: "/:catchAll(.*)",
    name: "Page404",
    component: () => import("./components/HeroBanner.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  routes
});

Vue.use(VueRouter);

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
